/**
 * UI atoms are used to store UI state that is not related to the data.
 * For example, the open state of a modal, the selected tab, the selected time-window, etc.
 */

import { atom } from "jotai";

export const timeWindowNoDataPopoverToggleAtom = atom<boolean | undefined>(false);
